import React, { useState } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Icons
import InfoIcon from '../../../icons/info.svg';

// Styles
import styles from './CharacteristicsCompact.styl';

const cx = classNames.bind(styles);

export default function CharacteristicsCompact(props) {
  const { className, characteristics } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  const onBlur = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return characteristics?.length > 0 ? (
    <div
      className={cx('CharacteristicsCompact', className)}
      onBlur={onBlur}
      role="button"
      tabIndex={0}
    >
      <InfoIcon
        className={cx('CharacteristicsCompact__icon')}
        onClick={e => {
          e.stopPropagation();
          toggle();
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.stopPropagation();
            toggle();
          }
        }}
      />
      <Transition in={isOpen} timeout={{ enter: 0, exit: 175 }} mountOnEnter unmountOnExit>
        {state => (
          <div
            className={cx(
              'CharacteristicsCompact__tooltip',
              `CharacteristicsCompact__tooltip_${state}`,
            )}
          >
            {characteristics.map(characteristic => (
              <div key={characteristic.code}>
                <div
                  style={{
                    marginTop: '8px',
                    fontSize: '14px',
                  }}
                >
                  {characteristic.name}
                </div>
                <div
                  style={{
                    marginTop: '8px',
                    color: '#cbcaca',
                    fontSize: '12px',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: characteristic.value,
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </Transition>
    </div>
  ) : null;
}

CharacteristicsCompact.defaultProps = {
  className: '',
};

CharacteristicsCompact.propTypes = {
  className: PropTypes.string,
  characteristics: PropTypes.array.isRequired,
};
